// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".add-creative-link-container {\n\tfont-size: 12px;\n\twidth: 100%;\n}\n\n.add-creative-link-container .title {\n\tpadding-left:5px;\n}\n", "",{"version":3,"sources":["AddCreativeButton.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB","file":"AddCreativeButton.css","sourcesContent":[".add-creative-link-container {\n\tfont-size: 12px;\n\twidth: 100%;\n}\n\n.add-creative-link-container .title {\n\tpadding-left:5px;\n}\n"]}]);
// Exports
module.exports = exports;
